import React from 'react';
import { useHistory } from 'react-router-dom';
import CustomButton from '../ui/buttons/Button';
import img404 from '../../assets/images/404.png'

export default function PrivateCustomerRoutes() {
    const history = useHistory();

    function goBackToHome() {
        history.push("/")
    }

    return (
        <div className='parent'>
        <div>
            <img src={img404} alt="" />
        </div>
            <div>
                <h1>404</h1>
                <h3>Sorry, the page you visited does not exist</h3>
                <CustomButton 
                    type='button'
                    cta='primary' 
                    onClick={goBackToHome} 
                    label='return to home page' 
                />
            </div>
        </div>
    )
}